var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "lang-cnt my-auto", style: _vm.cssProps }, [
    _vm.labeled ? _c("span", [_vm._v(_vm._s(_vm.$t("lang")) + ":")]) : _vm._e(),
    _vm._v(" "),
    _c(
      "span",
      {
        class: { active: _vm.isActive(_vm.esLocale) },
        style: _vm.cssProps,
        on: {
          click: function($event) {
            return _vm.$i18nHelpers.changeLang(_vm.esLocale)
          }
        }
      },
      [_vm._v("ES")]
    ),
    _vm._v(" "),
    _c(
      "span",
      {
        class: { active: _vm.isActive(_vm.EN_LOCALE) },
        style: _vm.cssProps,
        on: {
          click: function($event) {
            return _vm.$i18nHelpers.changeLang(_vm.EN_LOCALE)
          }
        }
      },
      [_vm._v("EN")]
    ),
    _vm._v(" "),
    _vm.enablePortuguese
      ? _c(
          "span",
          {
            class: { active: _vm.isActive(_vm.PT_LOCALE) },
            style: _vm.cssProps,
            on: {
              click: function($event) {
                return _vm.$i18nHelpers.changeLang(_vm.PT_LOCALE)
              }
            }
          },
          [_vm._v("PT")]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1abd792b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1abd792b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/LangSelector.vue
// module id = 1658
// module chunks = 116